<template>
<div class="container">
  <footer class="page-footer font-small pt-4">
    <div class="container-fluid text-center txt-time" dir="rtl">
      <span class="mr">
          <span> <i class="fa fa-calendar ico" aria-hidden="true"></i></span>
          <span>{{dte}}</span>
      </span>
      <span class="mr">
          <span><i class="fa fa-calendar ico" aria-hidden="true"></i></span>
          <span >{{dt}}</span>
      </span>
      <span class="mr">
          <span><i class="fa fa-clock ico" aria-hidden="true" ></i></span>
          <span>{{tm}}</span>
      </span>
  </div>
  <div class="footer-copyright text-center  py-3">
  <span>جميع الحقوق محفوظة لشركة صمم لتقنية المعلومات 2020</span>
  </div>
</footer>
</div>
</template>
<script>
export default {
    name:"footerv",
    data(){
      return{
        dte:null,
        dt:null,
        tm:null 
      }
    },
    methods:{
        loadDateTime: function() {
            
           setInterval(()=>{
        const event = new Date();
        const options = {
            weekday: "long",
            year: "numeric",
            month: "long",
            day: "numeric"
        }
        this.dte = event.toLocaleDateString('ar-EG', options);
        this.dt = event.toLocaleDateString('ar-SA', options);
        this.tm = event.toLocaleTimeString('ar-SA');
             },1000);}
        
    },
    created(){
      this.loadDateTime()
    }
    
}
</script>
<style lang="scss" scoped>

.ico{
font-size:20px;
font-weight:bold;
margin: 10px;
}

</style>
